import { Checkbox } from "antd";
import images from "../../assets";

const onChange = (e) => {
    console.log(`checked = ${e.target.checked}`);
};
export default function CustomizeColumnBox(props) {
    return (
        <div className="w-full px-2 bg-white justify-between rounded-lg shadow border border-[#eae6ed] justify-center items-center flex"
            draggable
        >
            <div className="p-1 justify-start items-center gap-2 flex">
                <Checkbox className="text-[#7a8699] text-base font-normal font-['Poppins'] leading-normal" onChange={onChange}>{props.titlename}</Checkbox>
            </div>
            <div className="justify-between items-center flex">
                <div className="w-6 h-6 relative">
                    <img src={images.dragHandle} />
                </div>
            </div>
        </div>
    )
}